import React from "react";
import VStack from "../../ui_atoms/VStack";
import { EarningType, Mission } from "../../__generated__/graphql";
import { useI18n } from "../../hooks/i18n-hooks";
import ListItem from "../../ui_atoms/ListItem";
import { Buildable } from "ts-essentials";
import { useTheme } from "../../hooks/use-theme";

type MissionEarningTypeProps = {
    mission: Buildable<Mission>;
    setEarningType: (type: EarningType) => void;
};

const MissionEarningType: React.FC<MissionEarningTypeProps> = ({ mission, setEarningType }) => {
    const i18n = useI18n();
    const { gridSize } = useTheme();
    return (
        <VStack style={{ marginHorizontal: -(gridSize / 2) }}>
            <ListItem
                testID="monthly-earning"
                title={i18n.t("screens.user.create_mission_earning_type.monthly.label")}
                description={i18n.t("screens.user.create_mission_earning_type.monthly.description")}
                checked={mission.currentContract?.earningType === EarningType.Monthly}
                selectable
                onPress={() => {
                    setEarningType(EarningType.Monthly);
                }}
            />
            <ListItem
                testID="daily-earning"
                title={i18n.t("screens.user.create_mission_earning_type.daily.label")}
                description={i18n.t("screens.user.create_mission_earning_type.daily.description")}
                checked={mission.currentContract?.earningType === EarningType.Daily}
                selectable
                onPress={() => {
                    setEarningType(EarningType.Daily);
                }}
            />
            <ListItem
                testID="hourly-earning"
                title={i18n.t("screens.user.create_mission_earning_type.hourly.label")}
                description={i18n.t("screens.user.create_mission_earning_type.hourly.description")}
                checked={mission.currentContract?.earningType === EarningType.Hourly}
                selectable
                onPress={() => {
                    setEarningType(EarningType.Hourly);
                }}
            />
            <ListItem
                testID="package-earning"
                title={i18n.t("screens.user.create_mission_earning_type.package.label")}
                description={i18n.t("screens.user.create_mission_earning_type.package.description")}
                checked={mission.currentContract?.earningType === EarningType.Package}
                selectable
                onPress={() => {
                    setEarningType(EarningType.Package);
                }}
                style={{ borderBottomWidth: 0 }}
            />
        </VStack>
    );
};

export default MissionEarningType;
